import { render, staticRenderFns } from "./V_Magazin.vue?vue&type=template&id=543b0ec6&"
import script from "./V_Magazin.vue?vue&type=script&lang=js&"
export * from "./V_Magazin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports